export default "__VITE_ASSET__BhH1wZiu__"